<div class="unrecoverable-error-container auth-shell">
  <div class="container vertical-center">
    <div class="auth-column">
      <img id="nice-img" class="auth-logo" src="assets/images/nice-logo-black-with-white.svg" [alt]="'login.logo' | translate"/>
      <div class="auth-card">
            <div id="status-failed">
              <svg id="status-failed-img" class="status-icon status-icon--critical" xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" aria-hidden="true" focusable="false">
                <g transform="translate(0.04)">
                  <path d="M36.571,9.76a3.08,3.08,0,0,0-4.469,0l-8.938,8.96L14.226,9.76a3.08,3.08,0,0,0-4.469,0,3.1,3.1,0,0,0,0,4.48L18.7,23.2,9.758,32.16a3.1,3.1,0,0,0,0,4.48,3.444,3.444,0,0,0,2.234.96,3.444,3.444,0,0,0,2.234-.96l8.938-8.96L32.1,36.64a3.08,3.08,0,0,0,4.469,0,3.1,3.1,0,0,0,0-4.48L27.633,23.2l8.938-8.96a3.093,3.093,0,0,0,0-4.48Z" transform="translate(8.796 8.8)" fill="currentColor"/>
                  <path d="M54.623,9.28A31.553,31.553,0,0,0,31.96,0,31.553,31.553,0,0,0,9.3,9.28a32.312,32.312,0,0,0,0,45.44A31.553,31.553,0,0,0,31.96,64a31.553,31.553,0,0,0,22.663-9.28,32.312,32.312,0,0,0,0-45.44ZM50.155,50.24a26.169,26.169,0,0,1-36.389,0,25.734,25.734,0,0,1,0-36.16A25.349,25.349,0,0,1,31.96,6.4a26.378,26.378,0,0,1,18.195,7.36,26.125,26.125,0,0,1,0,36.48Z" fill="currentColor"/>
                </g>
              </svg>
            </div>
            <div id="system-error-message">
              <p id="system-error-message-p">{{"system-error.message" | translate}}</p>
            </div>
            <div id="unrecoverable-error-message">
              <p id="unrecoverable-error-message-p">{{"unrecoverable-error.message" | translate}}</p>
            </div>
      </div>
    </div>
  </div>
  <footer class="copyRight-contactUs" id="copyRight-contactUs">
    <span id="copyrightMessage">{{copyrightMessage}}</span>
  </footer>
</div>
